import React from 'react'
import AboutUs from 'components/about-us/AboutUs'
import './About.css'

const About = () => {
  return (
    <div className="row" id='about-page'>
      <AboutUs/>
    </div>
  )
}

export default About